import React from 'react'

import { FieldProvider } from '../../providers/FieldProvider/FieldProvider'
import { useInstructions } from '../../providers/InstructionsProvider/useInstructions'
import { Compose } from '../../ui/Compose/Compose'

export const ComposeFeatureComponent = (props: any) => {
  const { id: instructionId, isConfigAllowed } = useInstructions({
    schemaPath: props?.clientProps?.schemaPath,
  })

  return (
    <FieldProvider
      context={{
        type: props?.clientProps?.field?.type,
        path: props?.clientProps?.path,
        schemaPath: props?.clientProps?.schemaPath,
      }}
    >
      <Compose
        descriptionProps={{
          field: props?.clientProps?.field,
          path: props?.clientProps?.path,
          schemaPath: props?.clientProps?.schemaPath,
          ...props?.clientProps,
        }}
        instructionId={instructionId}
        isConfigAllowed={isConfigAllowed}
      />
    </FieldProvider>
  )
}
